import React, { useRef } from "react";
import { ChevronDown } from "lucide-react";

import teamBadgePlaceholder from "../../../../assets/images/team_badge_placeholder.svg";

import TeamSelectorDropdown from "./TeamSelectorDropdown";


const TeamSlot = ({
  // Team data
  team,
  teamName,
  teamCrest,
  placeholderText = "Choose the team",
  showCrest = true,
  // Identifiers
  blockId,
  phaseId,
  slotIndex,
  assignSlot,
  // Selector state
  isSelectorOpen,
  teamSelectorRef,
  dropDirection = "down",
  zIndex = 9999,
  // Dropdown data
  progressionRuleText,
  availableTeams,
  // Callbacks
  onOpenSelector,
  onAssignTeam,
  onUnassignTeam,
  onRemoveRule,
  hasExplicitRule,
  // Rule assignment from click
  ruleSources = [],
  onAssignRule,
  // DnD components
  DroppableSlot,
  DraggablePosition,
  onDrop,
  phases,
}) => {
  const position = typeof assignSlot !== "undefined" ? assignSlot : slotIndex;
  const triggerRef = useRef(null);

  return (
    <DroppableSlot
      slot={position}
      blockId={blockId}
      phaseId={phaseId}
      phases={phases}
      onDrop={onDrop}
      style={isSelectorOpen ? { zIndex } : undefined}
    >
      <DraggablePosition
        position={position}
        blockId={blockId}
        phaseId={phaseId}
        onDrop={onDrop}
        item={
          <div
            className="relative"
            ref={isSelectorOpen ? teamSelectorRef : null}
          >
            <div
              ref={triggerRef}
              className="w-full px-[16px] py-[8px] bg-app-surface rounded-full cursor-pointer hover:bg-[#031A33] transition-colors flex justify-between items-center"
              onClick={onOpenSelector}
            >
              <div className="flex gap-[8px] items-center mr-2">
                {team.teamId ? (
                  <>
                    {showCrest && (
                      <img
                        src={teamCrest || teamBadgePlaceholder}
                        alt={teamName || "Team"}
                        className="w-5 h-5 rounded-full object-cover shrink-0 border border-[#192634]"
                        onError={(e) => {
                          e.target.src = teamBadgePlaceholder;
                        }}
                      />
                    )}
                    <span className="text-app-text text-[14px] font-medium">
                      {teamName || "Unknown Team"}
                    </span>
                  </>
                ) : (
                  <span className="text-app-text-secondary text-[14px] font-medium">
                    {progressionRuleText || placeholderText}
                  </span>
                )}
              </div>
              <ChevronDown size={20} />
            </div>

            <TeamSelectorDropdown
              isOpen={isSelectorOpen}
              teamId={team.teamId}
              progressionRuleText={progressionRuleText}
              availableTeams={availableTeams}
              onUnassignTeam={() => onUnassignTeam(team.teamId)}
              onRemoveRule={hasExplicitRule ? onRemoveRule : undefined}
              onAssignTeam={(availTeamId) => onAssignTeam(availTeamId, position)}
              ruleSources={ruleSources}
              onAssignRule={onAssignRule}
              dropDirection={dropDirection}
              triggerRef={triggerRef}
            />
          </div>
        }
      />
    </DroppableSlot>
  );
};

export default TeamSlot;
